// extracted by mini-css-extract-plugin
export default {"container":"Details_component_container__3c0XV","containerLoader":"Details_component_containerLoader__bteew","listItemText":"Details_component_listItemText__BQ7z3"};